module.exports = __webpack_public_path__ + "img/top.de887950.png";